<template>
    <svg v-bind="attributes" v-html="svgInner"></svg>
</template>

<script>
const parser = new DOMParser();

export default {
    props: {
        name: {
            type: String,
            required: true
        }
    },
    computed: {
        svgText() {
            if (!this.$icon(this.name)) {
                console.error(`SvgIcon: ${this.name} not found`);
            }

            return this.$icon(this.name);
        },
        svgDocument() {
            const document = parser.parseFromString(this.svgText, "image/svg+xml");
            return document;
        },
        svgInner() {
            return this.svgDocument.documentElement.innerHTML;
        },
        attributes() {
            const result = {};
            
            for (const attr of this.svgDocument.documentElement.attributes) {
                result[attr.name] = attr.value;
            }

            return result;
        }
    }
}
</script>
